import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React from 'react';
import Domain from './Domain';
const DomainCreateModal = ({isDomainCreateModalOpen, handleIsDomainCreateModalOpenToggle, firmName, firmId}) => {

   


    return (
        <MDBModal open={isDomainCreateModalOpen} onClose={handleIsDomainCreateModalOpenToggle}>
               <MDBModalDialog centered={true} size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Create Domain</MDBModalTitle>
               
            <MDBBtn size='sm' onClick={handleIsDomainCreateModalOpenToggle} >
                x
              </MDBBtn>
            </MDBModalHeader>
            <MDBModalBody><Domain fName={firmName} domainIModelClose={handleIsDomainCreateModalOpenToggle} firmId={firmId} isCreate={isDomainCreateModalOpen}/>
            
            </MDBModalBody>
      
          </MDBModalContent>
        </MDBModalDialog>
            </MDBModal>
    );
};
DomainCreateModal.propTypes = {
 
      key: PropTypes.string,
    handleIsDomainCreateModalOpenToggle: PropTypes.func,
    isDomainCreateModalOpen: PropTypes.bool,
    baseUrl: PropTypes.string,
    onDomainsUpdate: PropTypes.func,
    firmName: PropTypes.string,
    firmId: PropTypes.string,
    fetchItems: PropTypes.func,
}
export default DomainCreateModal;
